import { render, staticRenderFns } from "./HeaderRetailZone.vue?vue&type=template&id=19c18cb8&scoped=true"
import script from "./HeaderRetailZone.vue?vue&type=script&lang=js"
export * from "./HeaderRetailZone.vue?vue&type=script&lang=js"
import style0 from "./HeaderRetailZone.vue?vue&type=style&index=0&id=19c18cb8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c18cb8",
  null
  
)

export default component.exports